import React from 'react';
import MUITypography, {
  TypographyTypeMap as MUITypographyTypeMap,
  TypographyProps as MUITypographyProps,
} from '@mui/material/Typography';
import theme from 'common/theme';
import { MUIRef } from 'common/types/MUIRef.type';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export type TypographyProps = MUITypographyProps & { component?: React.ElementType };
export type TypographyTypeMap = MUITypographyTypeMap;
export type TypographyVariant = TypographyProps['variant'];

const Typography: React.FC<TypographyProps> = React.forwardRef(
  (props: TypographyProps, ref: MUIRef) => {
    const { children, ...typographyProps } = props;

    return (
      <MUITypography
        ref={ref}
        {...typographyProps}
        style={{ fontFamily: theme.typography.fontFamily }}
      >
        {children}
      </MUITypography>
    );
  },
) as OverridableComponent<TypographyTypeMap>;

export default Typography;
